import { Typography } from "@mui/material";

import { SHIPPER_UPGRADE_RELATIVE_URL } from "../../../../../constants";

export function FreeTierBannerText() {
  return (
    <Typography variant="h6" color="white" noWrap>
      <span style={{ color: "yellow" }}>
        <a
          style={{ textDecoration: "none", color: "yellow" }}
          href={SHIPPER_UPGRADE_RELATIVE_URL}
        >
          Upgrade now
        </a>
      </span>{" "}
      to access premium features!
    </Typography>
  );
}
